import { useState } from 'react';
import { LoaiVatTu, LoaiVatTuAccountData } from '@/types/schemas/loai-vat-tu.type';
import { AccountModel } from '@/types/schemas/account.type';

export type LoaiVatTuAccount = AccountModel | LoaiVatTuAccountData;

/**
 * Hook for managing search field states in the loai-vat-tu feature
 *
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = (initialData?: LoaiVatTu) => {
  const [warehouseAccount, setWarehouseAccount] = useState<LoaiVatTuAccount | null>(initialData?.tk_vt_data ?? null);
  const [revenueAccount, setRevenueAccount] = useState<LoaiVatTuAccount | null>(initialData?.tk_dt_data ?? null);
  const [costAccount, setCostAccount] = useState<LoaiVatTuAccount | null>(initialData?.tk_gv_data ?? null);
  const [discountAccount, setDiscountAccount] = useState<LoaiVatTuAccount | null>(initialData?.tk_ck_data ?? null);
  const [promotionAccount, setPromotionAccount] = useState<LoaiVatTuAccount | null>(initialData?.tk_km_data ?? null);
  const [returnAccount, setReturnAccount] = useState<LoaiVatTuAccount | null>(initialData?.tk_tl_data ?? null);
  const [wipAccount, setWipAccount] = useState<LoaiVatTuAccount | null>(initialData?.tk_spdd_data ?? null);
  const [materialAccount, setMaterialAccount] = useState<LoaiVatTuAccount | null>(initialData?.tk_cpnvl_data ?? null);

  return {
    warehouseAccount,
    setWarehouseAccount,
    revenueAccount,
    setRevenueAccount,
    costAccount,
    setCostAccount,
    discountAccount,
    setDiscountAccount,
    promotionAccount,
    setPromotionAccount,
    returnAccount,
    setReturnAccount,
    wipAccount,
    setWipAccount,
    materialAccount,
    setMaterialAccount
  };
};
